export const ORDER_ERROR_CODES: Record<string, string> = {
	'0000000': 'بدون خطا',
	'0000001': 'خطای پیش‌بینی نشده',
	'0000002': 'پیام نامعتبر',
	'0000003': 'سرور بیش از حد شلوغ',
	'0000004': 'داده نامعتبر',
	'0000005': 'عدم یافتن شماره پیگیری',
	'0000006': 'تجاوز از سقف مجاز تعداد درخواست در زمان معین',
	'0000007': 'بازار نامعتبر',
	'0000008': 'دسترسی غیرمجاز',
	'0000009': 'عدم پشتیبانی',
	'1000000': 'جلسه کاری نامعتبر',
	'1000001': 'نام کاربری و رمز عبور اشتباه',
	'1000002': 'شماره ترتیب اشتباه',
	'1000003': 'شماره پیگیری تکراری',
	'1000004': 'پذیرش درخواست',
	'1000005': 'درخواست اجرا شده',
	'1000006': 'خطا در اجرای درخواست',
	'1000007': 'رد پیام درخواست',
	'1000009': 'کد کارگزاری اشتباه',
	'1000010': 'عدم ارتباط با کارگزار',
	'1000012': 'شناسه مشتری نامعتبر',
	'2000000': 'ثبت موفق درخواست',
	'2000001': 'شناسه سفارش نادرست',
	'2000002': 'عدم دسترسی به سفارش ناظر',
	'2000003': 'شناسه نماد نادرست',
	'2000004': 'ثبت ناموفق درخواست',
	'2000005': 'عملیات بر روی سفارش غیرفعال',
	'2001000': 'عدم مجوز کارگزار',
	'2001001': 'عدم مجوز کارگزار جهت افزایش موقعیت تعهدی',
	'2001002': 'عدم مجوز مشتری جهت افزایش موقعیت تعهدی',
	'2001003': 'تجاوز از سقف موقعیت تعهدی مجاز مشتریان',
	'2001004': 'موجودی ناکافی',
	'2001005': 'دارایی ناکافی',
	'2001100': 'عدم امکان حذف در دوره پایانی',
	'2001101': 'عدم امکان حذف در دوره حراج تک قیمتی',
	'2001200': 'مشتری غیرفعال',
	'2001201': 'عدم ارتباط مشتری با کارگزار',
	'2001202': 'نماد غیرفعال',
	'2001203': 'نماد متوقف',
	'2001204': 'خارج از تاریخ معاملاتی نماد',
	'2001205': 'حداقل تغییر قیمت نادرست',
	'2001206': 'نماد بدون قیمت پایه',
	'2001207': 'قیمت خارج از محدوده مجاز',
	'2001208': 'حجم کمتر از یک',
	'2001209': 'حجم بیشتر از حد مجاز',
	'2001210': 'نماد غیرفعال برای معاملات آنلاین',
	'2001211': 'توصیف کننده قیمت نادرست',
	'2001212': 'نوع اعتبار زمانی نادرست',
	'2001300': 'عدم امکان ثبت سفارش خرید',
	'2001301': 'عدم امکان ثبت سفارش فروش',
	'2001302': 'ثبت خارج از فاز معاملاتی',
	'2001303': 'عدم امکان ثبت در دوره پایانی',
	'2001304': 'عدم امکان ثبت در دوره حراج تک قیمتی',
	'2001305': 'عدم سازگاری قیمت با مدت اعتبار سفارش',
	'2001306': 'عدم امکان ثبت سفارش با زمان محدود در فاز معاملاتی',
	'2001400': 'عدم امکان فعالسازی سفارش',
	'2001401': 'تغییر وضعیت خارج از فاز معاملاتی',
	'2001402': 'تغییر وضعیت در دوره حراج تک قیمتی',
	'2001403': 'تغییر وضعیت در دوره پایانی',
	'2001404': 'ویرایش خارج از فاز معاملاتی',
	'2001405': 'ویرایش در دوره حراج تک قیمتی',
	'2001406': 'مشخصات سفارش بدون تغییر (در ویرایش)',
	'2001407': 'عدم امکان تغییر مدت اعتبار سفارش',
	'2001408': 'عدم امکان تغییر قیمت سفارش به مارکت',
	'2010001': 'انتشار دهنده نامعتبر',
	'2010002': 'بازنشانی موفق انتشار دهنده معاملات',
	'2010003': 'بازنشانی موفق انتشار دهنده بازار',
	'2010004': 'بازنشانی موفق انتشار دهنده داده و عملیات',
	'2010005': 'شناسه جلسه معاملاتی نامعتبر',
	'3000001': 'عبور از محدودیت یک درخواست فعال',
	'3000003': 'رد درخواست انتقال وجه',
	'3000005': 'ثبت انتقال وجه خارج از زمان مجاز',
	'3010001': 'خارج از زمان ثبت آمادگی تحویل',
	'3020001': 'خارج از زمان ثبت اعمال',
	'3040001': 'رد درخواست',
	'3040002': 'عبور از محدودیت یک درخواست فعال',
	'3050001': 'ثبت ناموفق انتقال وجه کیف پول',
	'3050002': 'کافی نبودن موجودی کیف پول',
	'3050003': 'عدم وجود کیف پول',
	'3050004': 'نامعتبر بودن مقصد کیف پول',
	'3060000': 'شماره رهگیری نامعتبر',
	'3060001': 'در انتظار',
	'3060002': 'تاییدشده',
	'3060003': 'رد شده',
	'3060': 'بازه مجاز ثبت سفارش، 11:45 تا 18 است'
};
